import { observer } from "mobx-react";
import { h } from "preact";
import { t, translate } from "restaumatic-client";
import PreactTooltip from "./PreactTooltip";
const AvailableIcons = {
    Vegetarian: {
        label: translate(t.dish_settings.vegetarian),
        iconName: "svg-icon-vegetarian",
    },
    GlutenFree: {
        label: translate(t.dish_settings.gluten_free),
        iconName: "svg-icon-gluten-free",
    },
    LactoseFree: {
        label: translate(t.dish_settings.lactose_free),
        iconName: "svg-icon-lactose-free",
    },
    SeaFood: {
        label: translate(t.dish_settings.sea_food),
        iconName: "svg-icon-sea-food",
    },
    Vegan: {
        label: translate(t.dish_settings.vegan),
        iconName: "svg-icon-vegan",
    },
    Fit: {
        label: translate(t.dish_settings.fit),
        iconName: "svg-icon-fit",
    },
    Spicy: {
        label: translate(t.dish_settings.spicy1),
        iconName: "svg-icon-spicy-1",
    },
    VerySpicy: {
        label: translate(t.dish_settings.spicy2),
        iconName: "svg-icon-spicy-2",
    },
    SuperSpicy: {
        label: translate(t.dish_settings.spicy3),
        iconName: "svg-icon-spicy-3",
    },
    Bio: {
        label: translate(t.dish_settings.bio),
        iconName: "svg-icon-bio",
    },
    Children: {
        label: translate(t.dish_settings.children),
        iconName: "svg-icon-children",
    },
    Diabetic: {
        label: translate(t.dish_settings.diabetic),
        iconName: "svg-icon-diabetic",
    },
    Halal: {
        label: translate(t.dish_settings.halal),
        iconName: "svg-icon-halal",
    },
    Keto: {
        label: translate(t.dish_settings.keto),
        iconName: "svg-icon-keto",
    },
    Kosher: {
        label: translate(t.dish_settings.kosher),
        iconName: "svg-icon-kosher",
    },
    Local: {
        label: translate(t.dish_settings.local),
        iconName: "svg-icon-local",
    },
    LowCarb: {
        label: translate(t.dish_settings.low_carb),
        iconName: "svg-icon-low-carb",
    },
    Protein: {
        label: translate(t.dish_settings.protein),
        iconName: "svg-icon-protein",
    },
    Sugar: {
        label: translate(t.dish_settings.sugar),
        iconName: "svg-icon-sugar",
    },
    SugarFree: {
        label: translate(t.dish_settings.sugar_free),
        iconName: "svg-icon-sugar-free",
    },
};
function ProductTagsIcons(props) {
    const { tags, tooltipPlacement = "auto" } = props;
    const icons = tags
        .map((tag) => AvailableIcons[tag])
        .filter((v) => v !== undefined);
    return icons.length > 0 ? (h("span", { class: "dish-icons" }, icons.map((icon) => (h(PreactTooltip, { key: icon.iconName, title: icon.label, placement: tooltipPlacement, class: "dish-icons__list-item" },
        h("svg", { class: icon.iconName, width: "20", height: "20" },
            h("use", { href: `#${icon.iconName}` }))))))) : null;
}
export default observer(ProductTagsIcons);
